import {
  Container,
  TitleWrapper,
  CardsWrapper,
  CardWrapper,
  NoData,
} from './SimilarityCardsStyles';
import ThirdCard from '@/ui//card/thirdCard/ThirdCard';
import { useSelector } from 'react-redux';

interface SimilarityCardsProps {
  title?: string;
  cards?: any[];
  addCompanyList?: (card: any) => void;
}

const SimilarityCards = ({ title, cards = [], addCompanyList }: SimilarityCardsProps) => {
  const language = useSelector((state: any) => state.user.language);

  const handleClick = (card) => {
    addCompanyList({
      corp_code: card.corp_code,
      comp_name_ko: card[`corp_name_ko`],
      comp_name_en: card[`corp_name_en`],
      esg_risk: card.esg_risk,
      esg_risk_change_ratio: card.esg_risk_change_ratio,
    });
  };

  return (
    <Container>
      <TitleWrapper>
        <div className="text-text-500">{title}</div>
        {/* <QuestionIcon desc={desc} /> */}
      </TitleWrapper>
      {cards.length > 0 ? (
        <CardsWrapper>
          {cards?.map((card, i) => (
            <CardWrapper key={i}>
              <ThirdCard
                companyId={card.stock_code}
                // marketName={card[`stock_market_${language}`]}
                companyName={card[`corp_name_${language}`]}
                change={card.esg_risk_change_ratio}
                score={card.esg_risk}
                onClick={() => handleClick(card)}
              />
            </CardWrapper>
          ))}
        </CardsWrapper>
      ) : (
        <NoData>
          <div className="text-sm text-text-300">No Data</div>
        </NoData>
      )}
    </Container>
  );
};

export default SimilarityCards;
